import React, {useState, useEffect} from "react";
import { Row, Col, List,Button,Input, Divider } from 'antd';
import moment from "moment";
import 'moment/locale/el';
// import apptrackService from "../services/apptrack.service";
import { useDispatch, useSelector } from "react-redux";
import { addComment, getApptrackDetails, getComments } from "store/appTrack/actions";
import { useParams } from "react-router-dom";

const { TextArea } = Input;

function constructUserInfo(comment) {
  var userText = "";
  userText = "Ο χρήστης <b>" + comment.userName + "</b>";
  // switch (comment.userRole) {

  //   case "investor":
  //     userText = "Ο <b>Εγκαταστάτης</b>";
  //     break;
  //   case "bank":
  //     if ((comment.userFirstName != undefined && comment.userLastName != undefined) && comment.userOrganization != undefined) {
  //       userText = "Ο χρήστης <b>" + comment.userFirstName + " " + comment.userLastName + "</b> από το Πιστωτικό Ίδρυμα <b>" + comment.userOrganization + "</b>";
  //     }
  //     break;
  //   case "auditor":
  //     if (comment.userFirstName != undefined && comment.userLastName != undefined && comment.userOrganization != undefined) {
  //       userText = "Ο χρήστης <b>" + comment.userFirstName + " " + comment.userLastName + "</b> από την Συμβουλευτική <b>" + comment.userOrganization + "</b>";
  //     }
  //     break;
  //   default:
  //     if (comment.userFirstName != undefined && comment.userLastName != undefined) {
  //       userText = "Ο χρήστης <b>" + comment.userFirstName + " " + comment.userLastName + "</b>";
  //     }
  //     break;
  // }
  return userText;
}

function checkForTask(comment) {
  var taskText = "";

  if (comment.taskDescription != undefined && comment.taskDescription != "") {
    comment.userGroup.includes("G600_KTP") ? taskText = " κατά τη Διαδικασία: <b> Κατακύρωση της Αξιολόγησης </b>."
    : taskText = " κατά τη Διαδικασία: <b>" + comment.taskDescription + "</b>.";
  }
  else {
    taskText = ".";
  }
  return taskText;
}

function getDay(date){
  if(moment(date, "DD/MM/YYYY").format("DD/MM/YYYY") == moment().format("DD/MM/YYYY")){
    return "Σήμερα";
  }
  switch(moment(date, "DD/MM/YYYY").day()){
      case 0: 
      return "Κυριακή";
      case 1: 
      return "Δευτέρα";
      case 2: 
      return "Τρίτη";
      case 3: 
      return "Τετάρτη";
      case 4: 
      return "Πέμπτη";
      case 5: 
      return "Παρασκευή";
      case 6: 
      return "Σάββατο";
  }
}

function get12h(time){
  return moment(time).format('LT');
}

const Historicity = () => {
  
  const dispatch = useDispatch();
  const params = useParams();
  const [comment, setComment] = useState('');
  const [displayedComments, setDisplayedCommetns] = useState([]);
  const allComments = useSelector(state=> state.appTrack?.apptrackDetails?.comments);
  const [disabledComments, setDisabledComments] = useState(false);

  // console.log("comments:",allComments);

  useEffect(()=>{
    if(allComments){
      // console.log("COMMENTS:",allComments);
      // console.log("ENTERED");
      setDisplayedCommetns(allComments);
    }
  },[allComments])

  console.log("comments:",displayedComments);

  const handleChange = (event) => {
    setComment(event.target.value);
  }

  const onClear = () => {
    setComment('');
  }


  const AddComment = (id, value) => {
  if (value.length > 0) {
    dispatch(addComment(id, value))
      .then(() => {
        dispatch(getApptrackDetails(id));
        setComment('');
      })
      .catch(error => {
        console.error("Error while adding comment:", error);
      });
  }
};

  // const ApplicationHistoryList = commentList;


  useEffect(() => {

    (comment.replace(/\s+/g, ' ').trim().split(" ").length>500) ? setDisabledComments(true) : setDisabledComments(false)

  },[comment])


  // console.log("application list history", ApplicationHistoryList);
  return (
    <>
    {displayedComments.length>0 && 
    <Row gutter={16}>
      <Col span={24}>
        <List
          className="ApplicationHistoryList"
          itemLayout="vertical"
          dataSource={displayedComments}
          renderItem={(item, index) => (
            <List.Item

              extra={
                <>
                  {item.comments.filter(item=>item.countryCode!=="UK").map((comment, index) => (
                    <div className="comment-wrapper">
                      <div className="application-history-record-hour">{get12h(comment.time).toLocaleLowerCase()}</div>
                      {comment.type !== "update" && 
                      <div className={'history-purple-left-record' + ' application-history-record'}>
                        <span className="application-history-record-info" dangerouslySetInnerHTML={{ __html: constructUserInfo(comment) }}></span>
                        <span className="application-history-record-info"> καταχώρησε το σχόλιο <b>"{comment?.message}"</b></span> 
                        <span className="application-history-record-info" dangerouslySetInnerHTML={{ __html: checkForTask(comment) }}></span>
                      </div>
                     }
                      {comment.type === "update" && 
                      <div className='history-purple-left-record application-history-record'>
                        <span className="application-history-record-info" dangerouslySetInnerHTML={{ __html: comment.message }}></span>
                      </div>
                     }
                    </div>
                  ))}
                </>
              }
            >
              <List.Item.Meta
                title={<span className="application-history-record-day">{getDay(item.date)}</span>}
                description={<span className="application-history-record-date">{item.date}</span>}
              />

            </List.Item>
          )}
        />
      </Col>
    </Row>
    }
    <Row gutter={16} className="add_comment">
      <Col span={16} className="add_comment_wrapper">
        <div className="add-history-label">Προσθήκη σχολίου</div>
        <TextArea  id="comment" value={comment} className="comment-text" bordered onChange={handleChange}></TextArea>
        {disabledComments &&
          (
            <div role="alert" className="ant-form-item-explain-error mt-1 mb-2">
              Έχετε υπερβεί τον μέγιστο αριθμό λέξεων. Ο μέγιστος αριθμός αντιστοιχεί στις 500 λέξεις, ενώ το κείμενο περιλαμβάνει {comment.replace(/\s+/g, ' ').trim().split(" ").length} λέξεις
            </div>
          )}
        <div className="comment-actions">
        <Button className="application_btn cancel_comment" onClick={()=>onClear()}><span>Άκυρο</span></Button>
        <Button disabled={disabledComments} className="application_btn add_comment comment-page" onClick={()=>AddComment(params.taskId,comment)}  ><span>Προσθήκη</span></Button>
        </div>
   
      </Col>
    </Row>
    <Divider className="history-divider"/>
    </>
  );
};

export default Historicity;